<template>
  <div class="header">
    <HusleieLogo />
    <h3>{{ title }}</h3>
    <div class="header__benefits">
      <div>
        <i class="budicon-check-ui" />
        <span>ingen oppsigelsestid</span>
      </div>
      <div>
        <i class="budicon-check-ui" />
        <span>3 mnd fornøydgaranti</span>
      </div>
    </div>
    <a href="#tenancies" class="btn btn-sm btn-outline-secondary mt-3"> Se mine leieforhold </a>
  </div>
</template>

<script>
import Vue from 'vue';
import HusleieLogo from '@/components/HusleieLogo.vue';

export default Vue.extend({
  name: 'Header',
  components: {
    HusleieLogo,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.7rem 0rem;
  padding: 2.2rem;
  text-align: center;
}
.header__benefits {
  display: flex;
  flex-direction: column;
  padding: 0rem 2rem;
  gap: 0.4rem 0rem;
}
.header__benefits div {
  display: flex;
  gap: 0rem 0.5rem;
  align-items: center;
}

@media (min-width: 500px) {
  .header__benefits {
    flex-direction: row;
    gap: 0rem 2rem;
  }
}
</style>
